<template>
    <div id="t-supplier-about" class="cabinet-supplier-tab-content">
        <div class="v2-retailer-brand__about">
            {{ brand.Description }}

            <div class="v2-retailer-brand__about-links">
                <a
                    v-if="brand.WWW_Site"
                    :href="brand.WWW_Site"
                    target="_blank"
                    class="v2-retailer-brand__about-links-item v2-retailer-brand__about-links-item--site cabinet-link"
                >
                    {{ brand.WWW_Site }}
                </a>

                <a
                    v-if="brand.WWW_Instagram"
                    :href="brand.WWW_Instagram"
                    target="_blank"
                    class="v2-retailer-brand__about-links-social insta"
                ></a>
                <a
                    v-if="brand.WWW_Vkontakte"
                    :href="brand.WWW_Vkontakte"
                    target="_blank"
                    class="v2-retailer-brand__about-links-social vk"
                ></a>
                <a
                    v-if="brand.WWW_Facebook"
                    :href="brand.WWW_Facebook"
                    target="_blank"
                    class="v2-retailer-brand__about-links-social fb"
                ></a>
                <a
                    v-if="brand['whatsapp-link']"
                    :href="brand['whatsapp-link']"
                    target="_blank"
                    class="v2-retailer-brand__about-links-social wa"
                ></a>
            </div>

            <!-- <div v-if="isRegDateShown" class="v2-retailer-brand__about-table">
                <div class="v2-retailer-brand__about-table-key">
                    Регистрация на Goldnet
                </div>
                <div class="v2-retailer-brand__about-table-val">
                    {{ getFormattedDate(brand.supplier.created_at) }}
                </div>
            </div> -->
        </div>
    </div>
</template>

<script>
import getFormattedDate from '@/utils/getFormattedDate'

export default {
    name: 'PublicBrandAbout',
    props: {
        brand: {
            type: Object,
            required: true
        }
    },
    computed: {
        isRegDateShown() {
            //выводим только при наличии у бренда не менее 6 изделий или > 0 изделий для микро-поставщиков (users.no_products_email=1)
            return (
                this.brand.total_items_count >= 6 ||
                (this.brand.supplier.no_products_email &&
                    this.brand.total_items_count > 0)
            )
        }
    },
    methods: {
        getFormattedDate
    }
}
</script>
